import { render } from "./B2bPageRecadvsEmit.vue?vue&type=template&id=2a953dac&scoped=true&lang=pug"
import script from "./B2bPageRecadvsEmit.vue?vue&type=script&lang=js"
export * from "./B2bPageRecadvsEmit.vue?vue&type=script&lang=js"

import "./B2bPageRecadvsEmit.vue?vue&type=style&index=0&id=2a953dac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a953dac"]])

export default __exports__